import React from 'react';
import { connect } from "react-redux";
import { NavLink, withRouter } from 'react-router-dom';
import Button from '../../Button';

function NotificationNewTerms(props)  {

  return (
    <div className="page notification">
      <section>
        <div className="page-header">
          <h1>Drogi BAT Partnerze!</h1>
          <p>Informujemy, że w związku z par 11 pkt 3.e wprowadzamy zmiany w Regulaminie BAT Partners.</p>
          <p>Zmiany dotyczą uszczegółowienia zapisów w par.1 pkt14.  par 4. Pkt 3-4-5 oraz 8, a także par 5 pkt 4.</p>
          <p>Przypominamy, że w związku z wprowadzeniem banderoli akcyzowej na liquidy do e-papierosów, sprzedaż zestawów startowych Vype ePen 3 od 1maja nie będzie uwzględniana w programie.</p>
          <a className="btn" href="/assets/regulamin_bat_partners_2021_210409.pdf" target="_blank">Regulamin</a>
        </div>
      </section>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { screen, user } = state
  return { screen, user }
};

export default withRouter(connect(
  mapStateToProps,
  {

  }
)(NotificationNewTerms));